import { CallSegment } from '../../store/reducers/calls/reducer';
import { makeStyles } from '@material-ui/styles';
import { Colors } from '../../styles/Colors';

export const useStyle = makeStyles(() => ({
    container: {
        display: 'flex',
        width: '90%',
        minWidth: 0,
        justifyItems: 'flex-start',
        columnGap: 37,
        padding: '2px 4px',
        borderWidth: 1,
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderRadius: 12,
        transition: 'all 0.2s ease-in-out',
        alignItems: 'center',
        fontSize: 14,

        '& svg:last-of-type ': {
            visibility: 'hidden',
            opacity: 0,
            maxWidth: 16,
            maxHeight: 16,
            cursor: 'pointer',
            marginTop: 5,
        },

        '&:hover svg:last-of-type': {
            visibility: 'visible',
            opacity: 1,
        },

        '&:hover': {
            backgroundColor: Colors.LightGraySecondary7,
        },

        '& > div:first-child' : {
            justifyContent: 'end',
        },

        '& > div:first-child > span': {
            borderBottomStyle: 'dashed',
            borderBottomWidth: 1,
            borderBottomColor: 'transparent',
        },

        '&:hover > div:first-child > span': {
            borderBottomStyle: 'dashed',
            borderBottomWidth: 1,
            borderBottomColor: Colors.Secondary2,
            color: Colors.Secondary2,
        },
    },

    full: {
        width: 'unset',
        gap: 8,
        display: 'flex',
        padding: '5px 8px',
        alignItems: 'center',
        alignSelf: 'stretch',
    },

    actionContainer: {
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
        padding: '0 8px',
        minWidth: '40px',
        justifyItems: 'start',
    },

    textArea: {
        display: 'flex',
        width: '85%',
        justifyItems: 'flex-start',
        columnGap: '37px',
        borderWidth: '1px',
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderRadius: '4px',
        transition: 'all 0.2s ease-in-out',
        fontFamily: 'inherit',
        resize: 'none',
        border: 'none',
        outline: 'none',
        background: 'transparent',
        boxShadow: 'none',
        padding: 'inherit',
        overflow: 'hidden',
        lineHeight: '19px',
    },

    save: {
        color: Colors.Secondary2,
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '16px',
        cursor: 'pointer',
        alignSelf: 'center',
        padding: '0 8px',
    },

    saveDisabled: {
        color: Colors.Secondary2,
        opacity: '.5',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '16px',
        cursor: 'not-allowed',
        alignSelf: 'center',
        padding: '0 8px',
    },

    edited: {
        color: Colors.Secondary2,
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px',
        alignSelf: 'center',
        padding: '0',
        fontStyle: 'italic',
    },

    edit: {
        borderRadius: '8px 8px 0px 0px',
        borderBottom: '2px solid' + Colors.Secondary2,
        background: Colors.White,
        boxShadow:
            '-1px 0px 0px 0px rgba(0, 0, 0, 0.15) inset, 1px 0px 0px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.15) inset',
        '&:hover': {
            backgroundColor: Colors.White,
        },

        '&:hover > div:first-child > span': {
            borderBottomStyle: 'dashed',
            borderBottomWidth: 1,
            borderBottomColor: 'transparent',
            color: Colors.Secondary2,
        },

        '& > div:first-child > span ': {
            borderBottomStyle: 'dashed',
            borderBottomWidth: 1,
            borderBottomColor: 'transparent',
            color: Colors.Secondary2,
        },
    },

    active: {
        borderColor: Colors.Primary,
        backgroundColor: Colors.White,
        transition: 'all 0.2s ease-in-out',

        '& div:first-child  svg': {
            visibility: 'visible',
            opacity: 1,
        },

        '&:hover': {
            backgroundColor: Colors.White,
        },

        '& > div:first-child > span': {
            borderBottomStyle: 'dashed',
            borderBottomWidth: 1,
            borderBottomColor: 'transparent',
        },

        '&:hover > div:first-child > span': {
            borderBottomStyle: 'dashed',
            borderBottomWidth: 1,
            borderBottomColor: Colors.Primary,
            color: Colors.Primary,
        },
    },

    silence: {
        fontStyle: 'italic',
        color: Colors.Text,
        opacity: '.4',

        '& div:first-child > span': {
            color: Colors.Text,
            opacity: '.4',
        },

        '&:hover': {
            backgroundColor: 'transparent',
        },

        '&:hover > div:first-child > span': {
            borderBottom: '1px solid transparent',
            color: Colors.Secondary2,
            opacity: 1,
        },
    },
}));

export interface TranscriptionRowInterface {
    start: string;
    end: string;
    duration?: string;
    search?: string;
    text: string;
    active: boolean;
    id: string;
    matchIndex?: number;
    rowNumber?: number;
    searchMatrix?: number[][];
    callSegment?: CallSegment;
    full?: boolean;
    moveProgress?: (val: number) => void;
    readOnly?: boolean;
}
